import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StyleLoaderService {
  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }


  loadStyle(fileName: string) {
    const linkEl = this.getLinkEl(fileName);

    if (linkEl) {
      return;
    }

    const style = this.document.createElement('link');
    style.rel = 'stylesheet';
    style.href = `${fileName}`;

    this.getHead().appendChild(style);
  }

  removeStyle(fileName: string) {
    const linkEl = this.getLinkEl(fileName);
    linkEl?.remove();
  }

  replaceStyle(currentFileName: string, replaceWithFileName: string) {
    this.removeStyle(currentFileName);
    this.loadStyle(replaceWithFileName);
  }

  private getHead() {
    return this.document.getElementsByTagName('head')[0];
  }

  private getLinkEl(fileName: string) {
    return document.querySelector(`[href="${fileName}"]`);
  }
}
